import { CompanyType } from "$types/CompanyType";
import { Popin, Text } from "$components";
import UserForm from "$containers/Coordinators/UserForm";
import DockyardForm from "$containers/Dockyard/DockyardForm";
import EntrepotForm from "$containers/Entrepot/EntrepotDetails/EntrepotForm";
import EntrepriseForm from "$containers/Entreprises/EntrepriseForm";
import { useDeliveryEDBContext } from "$containers/EDB/ProfileEDB/context/DeliveryContext";

export default function Modals() {
  const {
    useDockyardClasses,
    togglePopin,
    handleSubmitDockyard,
    isDockyardPopinOpened,
    errorDockyard,
    submitting,
    handleSubmitWarehouse,
    handleSubmitContact,
    openNewContactPopin,
    toggleNewContactDrawer,
    errorUser,
    handleSubmitIntervenant,
    toggleIntervenantPopin,
    isIntervenantOpened,
    companyError,
    intervenantSubmitting,
    toggleWarehousePopin,
    isWarehousePopinOpened,
    error,
    warehouseSubmitting,
    isIntervenantCompanyClient,
    dockyard,
    intervenantCompany,
  } = useDeliveryEDBContext();

  return (
    <>
      {/* popin chantier */}
      <Popin
        className={useDockyardClasses.ProjectsPage_Popin}
        openPopin={isDockyardPopinOpened}
        toggleDrawer={togglePopin}
      >
        <DockyardForm
          dockyard={dockyard}
          onSubmit={handleSubmitDockyard}
          onCancel={() => togglePopin(false)}
          error={errorDockyard}
          isSubmitting={submitting}
        />
      </Popin>

      {/* popin entreprise intervenante */}
      <Popin
        openPopin={isIntervenantOpened}
        toggleDrawer={toggleIntervenantPopin}
      >
        <EntrepriseForm
          readOnlyFields={["companyTypes", "contributorOf"]}
          defaultValues={{
            companyTypes: [CompanyType.CONTRIBUTOR],
            contributorOf: [dockyard?.company],
          }}
          onSubmit={handleSubmitIntervenant}
          onReset={() => toggleIntervenantPopin(false)}
          companyError={companyError}
          isSubmitting={intervenantSubmitting}
        />
      </Popin>

      {/* popin contact intervenant */}
      <Popin
        openPopin={openNewContactPopin}
        toggleDrawer={toggleNewContactDrawer}
      >
        <Text type="h2">
          {isIntervenantCompanyClient
            ? "Ajouter un contact"
            : "Ajouter un contact intervenant"}
        </Text>
        <UserForm
          onSubmit={handleSubmitContact}
          onReset={() => toggleNewContactDrawer(false)}
          isCoordinator={false}
          error={errorUser}
          canBeUser
        />
      </Popin>

      {/* popin entrepot */}
      <Popin
        openPopin={isWarehousePopinOpened}
        toggleDrawer={toggleWarehousePopin}
      >
        <Text type="h2">Ajouter un entrepôt</Text>
        <EntrepotForm
          parentCompanyId={intervenantCompany}
          onSubmit={handleSubmitWarehouse}
          onReset={() => toggleWarehousePopin(false)}
          isSubmitting={warehouseSubmitting}
          entrepotError={error}
        />
      </Popin>
    </>
  );
}
